import React from 'react'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { PageLayout } from '@components/common/PageLayout'
import { BackButton, ButtonClean } from '@fourthwall/components'
import { routing } from '@utils/routing'

import type { FormValues } from './NewDomain.types'
import * as S from './NewDomainView.styled'
import { DomainForm } from './components/DomainForm/DomainForm'

type NewDomainViewProps = {
  isLoading: boolean
  onSubmit: (values: FormValues, onError: (message: string) => {}) => void
}

export const NewDomainView = ({ isLoading, onSubmit }: NewDomainViewProps) => (
  <PageLayout size="small">
    <Dashboard.Section
      name="Connect a domain to your site"
      title={
        <S.DescriptionContainer>
          We’re excited to help you set up your custom domain! To connect a custom domain, you need
          to own the domain you want to connect. If you haven’t purchased a domain yet we recommend
          using{' '}
          <ButtonClean
            appearance="primary"
            label="Porkbun"
            href="https://porkbun.com/"
            target="_blank"
          />
          . If you have purchased a domain, enter it below to connect it to your site.{' '}
          <ButtonClean
            label="Learn more"
            href="https://help.fourthwall.com/hc/en-us/articles/13331283794587-How-do-I-use-a-custom-domain"
            target="_blank"
          />
        </S.DescriptionContainer>
      }
      titleSpacing="medium"
      topContent={<BackButton label="Domains" to={routing.settings.domain.self} />}
    >
      <DomainForm isLoading={isLoading} onSubmit={onSubmit} />
    </Dashboard.Section>
  </PageLayout>
)
